import { observable, action } from 'mobx'
import Api from '@api/kong_kong/CardAddApi'

class Store {
  @observable id = 1
  @observable checkList = []

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  @action
  pushList = data => {
    const id = this.id
    this.checkList.push({
      id,
      checked: false,
      msg: '',
      ...data
    })
    this.id++
    return id
  }

  @action
  changeValue = (id, value) => {
    const data = this.checkList.find(item => item.id == id)
    data.value = value
    data.checked = false
    data.msg = ''
  }

  @action
  replaceItem = (id, msg) => {
    const data = this.checkList.find(item => item.id == id)
    data.checked = true
    data.msg = msg
  }

  @action
  resetItem = id => {
    const data = this.checkList.find(item => item.id == id)
    data.checked = false
    data.msg = ''
  }

  @action
  removeList = id => {
    const idx = this.checkList.findIndex(item => item.id == id)
    this.checkList.splice(idx, 1)
  }

  @action
  checkWord = async (content, type = 2) => {
    console.log(content)
    if (!content) {
      return { code: 0, keywords: [] }
    }
    const { data } = await Api.checkWord({ content, type })
    return data
  }

  @action
  checkAll = async () => {
    let flag = false
    for (const item of this.checkList) {
      if (!item.checked && !!item.value) {
        const data = await this.checkWord(item.value, item.type)
        if (data.code == 1) {
          flag = true
          data.msg = data.keywords.join(',')
          data.checked = true
        }
      } else if (item.msg) {
        flag = true
      }
    }

    for (const item of this.checkList) {
      if (item.msg) {
        flag = true
      }
    }
    return flag
  }

  @action
  reset = () => {
    this.checkList.length = 0
  }
}

export default new Store()
